import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import classNames from 'classnames';

import DetailScroll from 'components/Detail/Scroll';
import { getSidebarStatus } from 'containers/App/selectors';

const LoadingIndicator = ({
  sidebarStatus, color = 'accent0', customClass, scrollClass, isProcessPage, title, description, children
}) => {
  const mainClass = classNames('loading_icon loading_icon_page', {
    loader_expand: sidebarStatus,
    [color]: color,
    [customClass]: customClass,
    'full-page': isProcessPage,
  });

  return (
    <DetailScroll isProcessPage hideBanner customClass={scrollClass}>
      <div className={mainClass}>
        <div className="boxes">
          <div className="box">
            <div />
            <div />
            <div />
            <div />
          </div>
          <div className="box">
            <div />
            <div />
            <div />
            <div />
          </div>
          <div className="box">
            <div />
            <div />
            <div />
            <div />
          </div>
          <div className="box">
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      </div>

      {title && <div>
        <div className='loading-container'>
          <div className='loading-title'>{title}</div>
          <div className='loading-desc'>{description}</div>
          {children}
        </div>
      </div>
      }

    </DetailScroll>
  );
};


const mapStateToProps = createStructuredSelector({
  sidebarStatus: getSidebarStatus(),
});

const withConnect = connect(
  mapStateToProps,
);

export default withConnect(LoadingIndicator);
